import { login as AuthLogin, checkLoggedIn as AuthCheck, logout as AuthLogout } from './services/auth.service';

const namespace = 'AUTH';
export const SET_IS_LOGGED = `${namespace}_SET_IS_LOGGED`;
export const SET_USER = `${namespace}_SET_USER`;
export const LOGOUT = `${namespace}_LOGOUT`;

const setIsLogged = (payload) => ({
  type: SET_IS_LOGGED,
  payload,
});

export const login = (params) => async (dispatch) => {
  try {
    const decoded = await AuthLogin(params);
    dispatch({
      type: SET_USER,
      payload: {
        user: decoded.user,
        company: decoded.company,
        isAdmin: decoded.user.role === 0,
      },
    });
    dispatch(setIsLogged(true));
  } catch (e) {
    console.log('login error', e);
    dispatch(setIsLogged(false));
    throw e;
  }
};

export const checkLoggedIn = () => async (dispatch) => {
  const decoded = await AuthCheck();

  if (decoded.isAuth) {
    dispatch(setIsLogged(true));

    return dispatch({
      type: SET_USER,
      payload: {
        user: decoded.user,
        company: decoded.company,
        isAdmin: decoded.user.role === 0,
      },
    });
  }
  
  dispatch(setIsLogged(false));
};

export const logout = () => (dispatch) => {
  AuthLogout();
  dispatch(setIsLogged(false));
};
